import React, { useState, useEffect, useRef,createRef } from "react";
import growthicon from "../../../assets/img/GG210.png";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { BiArrowBack } from "react-icons/bi";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import * as yup from "yup";
import { Formik } from "formik";
import Navigation from "../../../common/Navigation";
import { API_AUTH} from "../../../utils/config.js";
// import ReCAPTCHA from "react-google-recaptcha";
import { Input } from "reactstrap";

//  signinpassword component
const Signinpassword = () => {
  let location = useLocation();
  let history = useHistory();

  const [err, seterr] = useState("");
  const [valid, setvalid] = useState(false);
  const textInput = useRef(null);
  const [hidden, setHidden] = useState(true);
  const[token,setToken] = useState("")

  // const reCaptcha = createRef()

  useEffect(() => {
    checkingCurrentUser();

    textInput.current.focus();
  });

  // checking current candidate function

  const checkingCurrentUser = () => {
    axios
      .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
      .then((response) => {
        if (response.data) {
          history.push({
            pathname:"/dashboard"
          })
        //  window.location = "/dashboard"
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // onchange toggle show function

  const toggleShow = () => {
    setHidden(!hidden);
};

// validation schema

  const passValidationSchema = yup.object().shape({
    password: yup
      .string()
      .min(8, ({ min }) => `Password must be at least ${min} characters`)
      .required("Password is required"),
  });


  // const onChangeToken = (token) => {
  // setToken(token)
  // seterr("")
  // }

  // const resetToken = () =>{
  // setToken("")
  // seterr("")
  // }

  // onSubmit function when submit button triggers

  const handleSubmit = async (password) => {
    console.log(location.state)
    let body = {
      email: location.state,
      password,
      // token:token,
      ipAddress: "150.82.224.211",
      browser: "",
      OS: "",
      isTablet: false,
      isPhone: false,
      isBot: false,
      location: "",
      isSuspicious: false,
    };

    // if(token){
      await axios
      .post(`${API_AUTH}/v1/api/auth/login`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.ok) {
          // history.push({
          //   pathname:"/dashboard"
          // })
         window.location = "/dashboard"
        } else if (!response.data.ok) {
          setvalid(true);
          seterr(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // }
    // else{
    //   setvalid(true);
    //   seterr("You must verify the captcha")
    // }

   
  };

  return (
    <>
       <Navigation show="true" />
      <Formik
        validationSchema={passValidationSchema}
        initialValues={{ password: "" }}
        onSubmit={(values) => handleSubmit(values.password)}
      >
        {({ handleChange, handleSubmit, values, errors, touched, isValid }) => (
          <>
            <div className="sign-container">
              <div className="child-signcontainer">
                <Link
                  style={{
                    color: "#005500",
                    marginLeft: "30px",
                  
                  }}
                  to="/signin"
                >
                  {" "}
                  <h4>
                    {" "}
                    <BiArrowBack />{" "}
                  </h4>
                </Link>
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "1.5rem" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>
                </div>

                <div style={{marginTop:"2rem"}} className="child-secondcontainer">
                  <span style={{ fontWeight: 500, fontSize: "20px" }}>
                    Enter Password
                  </span>

                  <div className="sign-form">
                    <input
                      ref={textInput}
                      type={hidden ? "password" : "text"}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      name="password"
                      onChange={(password) => {
                        handleChange(password);
                        setvalid(false);
                      }}
                      value={values.password}
                      placeholder="Password"
                      autoComplete="off"
                      required
                    ></input>
                    {errors.password && touched.password && (
                      <span style={{ fontSize: 15, color: "red" }}>
                        {errors.password}
                      </span>
                    )}

                    {err && valid && (
                      <span style={{ fontSize: 15, color: "red" }}>{err}</span>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",

                      marginTop: "-10px",
                    }}
                  >
                    <Input type="checkbox" onClick={toggleShow} />
                    <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                      Show Password
                    </span>
                  </div>

                  <div style={{ display: "flex", marginTop: "1.2rem" }}>
                    <span style={{ fontSize: "14px" }}>
                      <Link
                        style={{ color: "#005500", textDecoration: "none" }}
                        to="/forget_password"
                      >
                        Forgot Password ?
                      </Link>{" "}
                    </span>
                  </div>
                  {/* <div style={{marginTop:"0.5rem"}}>
                  <ReCAPTCHA
                  size="normal"
                 ref={reCaptcha}
                 sitekey={RECAPTCHA_SITE_KEY}
                 onChange={onChangeToken}
                 onErrored={resetToken}
                 />
                  </div> */}
                </div>
                <div style={{ marginBottom: "1rem" }} className="log-button">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{
                      background: "#005500",
                      marginBottom: "10px",
                      marginLeft: "350px",
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
};

export default Signinpassword;
